"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyWhenSinceSourceEnum = void 0;
var JourneyWhenSinceSourceEnum;
(function (JourneyWhenSinceSourceEnum) {
    JourneyWhenSinceSourceEnum["Created"] = "Created";
    JourneyWhenSinceSourceEnum["Resolved"] = "Resolved";
    JourneyWhenSinceSourceEnum["Closed"] = "Closed";
    JourneyWhenSinceSourceEnum["ReOpened"] = "ReOpened";
    JourneyWhenSinceSourceEnum["FirstAssigned"] = "FirstAssigned";
    JourneyWhenSinceSourceEnum["Assigned"] = "Assigned";
    JourneyWhenSinceSourceEnum["RequesterResponded"] = "RequesterResponded";
    JourneyWhenSinceSourceEnum["AgentResponded"] = "AgentResponded";
    JourneyWhenSinceSourceEnum["UntilFirstResponseDue"] = "UntilFirstResponseDue";
    JourneyWhenSinceSourceEnum["FirstResponseOverdue"] = "FirstResponseOverdue";
    JourneyWhenSinceSourceEnum["UntilAnyResponseDue"] = "UntilAnyResponseDue";
    JourneyWhenSinceSourceEnum["AnyResponseOverdue"] = "AnyResponseOverdue";
    JourneyWhenSinceSourceEnum["UntilResolutionTime"] = "UntilResolutionTime";
    JourneyWhenSinceSourceEnum["ResolutionTimeOverdue"] = "ResolutionTimeOverdue";
    JourneyWhenSinceSourceEnum["WaitingForThirdParty"] = "WaitingForThirdParty";
})(JourneyWhenSinceSourceEnum = exports.JourneyWhenSinceSourceEnum || (exports.JourneyWhenSinceSourceEnum = {}));
